import {apiSlice} from '../apiSlice';

const USERS_URL = '/users';

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: (token) => ({
                url: `${USERS_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        })
    }),
});

export const {
    useGetUsersQuery
} = userApiSlice;
